import QrPlane from '../../../assets/ass/auth/QrPlane.ass';
import BannedDuck from '../../../assets/ass/BannedDuck.ass';
import BrokenGift from '../../../assets/ass/BrokenGift.ass';
import CameraFlip from '../../../assets/ass/calls/CameraFlip.ass';
import HandFilled from '../../../assets/ass/calls/HandFilled.ass';
import HandOutline from '../../../assets/ass/calls/HandOutline.ass';
import Speaker from '../../../assets/ass/calls/Speaker.ass';
import VoiceAllowTalk from '../../../assets/ass/calls/VoiceAllowTalk.ass';
import VoiceMini from '../../../assets/ass/calls/VoiceMini.ass';
import VoiceMuted from '../../../assets/ass/calls/VoiceMuted.ass';
import VoiceOutlined from '../../../assets/ass/calls/VoiceOutlined.ass';
import CraftProgress from '../../../assets/ass/CraftProgress.ass';
import Diamond from '../../../assets/ass/Diamond.ass';
import DiamondReaction from '../../../assets/ass/diamonds/DiamondReaction.ass';
import DiamondReactionEffect from '../../../assets/ass/diamonds/DiamondReactionEffect.ass';
import DuckNothingFound from '../../../assets/ass/DuckNothingFound.ass';
import Flame from '../../../assets/ass/general/Flame.ass';
import Fragment from '../../../assets/ass/general/Fragment.ass';
import Mention from '../../../assets/ass/general/Mention.ass';
import PartyPopper from '../../../assets/ass/general/PartyPopper.ass';
import PlayPause from '../../../assets/ass/general/PlayPause.ass';
import Invite from '../../../assets/ass/invites/Invite.ass';
import JoinRequest from '../../../assets/ass/invites/Requests.ass';
import LastSeen from '../../../assets/ass/LastSeen.ass';
import Eyes from '../../../assets/ass/message/Eyes.ass';
import Typing from '../../../assets/ass/message/Typing.ass';
import Writing from '../../../assets/ass/message/Writing.ass';
import MonkeyClose from '../../../assets/ass/monkeys/TwoFactorSetupMonkeyClose.ass';
import MonkeyIdle from '../../../assets/ass/monkeys/TwoFactorSetupMonkeyIdle.ass';
import MonkeyPeek from '../../../assets/ass/monkeys/TwoFactorSetupMonkeyPeek.ass';
import MonkeyTracking from '../../../assets/ass/monkeys/TwoFactorSetupMonkeyTracking.ass';
import ReadTime from '../../../assets/ass/ReadTime.ass';
import Report from '../../../assets/ass/Report.ass';
import Search from '../../../assets/ass/Search.ass';
import SearchingDuck from '../../../assets/ass/SearchingDuck.ass';
import Congratulations from '../../../assets/ass/settings/Congratulations.ass';
import DiscussionGroups from '../../../assets/ass/settings/DiscussionGroupsDucks.ass';
import DuckCake from '../../../assets/ass/settings/DuckCake.ass';
import Experimental from '../../../assets/ass/settings/Experimental.ass';
import FoldersAll from '../../../assets/ass/settings/FoldersAll.ass';
import FoldersNew from '../../../assets/ass/settings/FoldersNew.ass';
import FoldersShare from '../../../assets/ass/settings/FoldersShare.ass';
import HandStop from '../../../assets/ass/settings/HandStop.ass';
import Lock from '../../../assets/ass/settings/Lock.ass';
import Passkeys from '../../../assets/ass/settings/Passkeys.ass';
import UtyanDisappear from '../../../assets/ass/settings/UtyanDisappear.ass';
import Unlock from '../../../assets/ass/Unlock.ass';
import BrokenGiftPreview from '../../../assets/broken-gift.svg';
import DuckNothingFoundPreview from '../../../assets/tgs-previews/DuckNothingFound.svg';
import WritingPreview from '../../../assets/tgs-previews/message/Writing.svg';
import PausePreview from '../../../assets/tgs-previews/Pause.svg';
import PlayPreview from '../../../assets/tgs-previews/Play.svg';
import SearchPreview from '../../../assets/tgs-previews/Search.svg';
import HandStopPreview from '../../../assets/tgs-previews/settings/HandStopPreview.png';
import PasskeysPreview from '../../../assets/tgs-previews/settings/Passkeys.svg';

export const LOCAL_TGS_PREVIEW_URLS = {
  HandStop: HandStopPreview,
  PlayPause: PlayPreview,
  PlayPausePaused: PausePreview,
  BrokenGift: BrokenGiftPreview,
  DuckNothingFound: DuckNothingFoundPreview,
  Search: SearchPreview,
  Passkeys: PasskeysPreview,
  Writing: WritingPreview,
};

export const LOCAL_TGS_URLS = {
  MonkeyIdle,
  MonkeyTracking,
  MonkeyClose,
  MonkeyPeek,
  FoldersAll,
  FoldersNew,
  FoldersShare,
  DiscussionGroups,
  Lock,
  CameraFlip,
  HandFilled,
  HandOutline,
  Speaker,
  VoiceAllowTalk,
  VoiceMini,
  VoiceMuted,
  VoiceOutlined,
  JoinRequest,
  Invite,
  QrPlane,
  Congratulations,
  Experimental,
  PartyPopper,
  PlayPause,
  Flame,
  ReadTime,
  Unlock,
  LastSeen,
  Mention,
  Fragment,
  DiamondReactionEffect,
  DiamondReaction,
  Report,
  SearchingDuck,
  BannedDuck,
  BrokenGift,
  CraftProgress,
  Diamond,
  Search,
  DuckNothingFound,
  Passkeys,
  UtyanDisappear,
  DuckCake,
  HandStop,
  Writing,
  Typing,
  Eyes,
};
